import { render, staticRenderFns } from "./ReferenceImage3dScene.vue?vue&type=template&id=faffec80&"
import script from "./ReferenceImage3dScene.vue?vue&type=script&lang=js&"
export * from "./ReferenceImage3dScene.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/annotation.css?vue&type=style&index=0&lang=css&"
import style1 from "./ReferenceImage3dScene.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports